/**
 * Simple event emitter for authentication events.
 * Used to communicate between api.js interceptors and AuthContext.
 */

class AuthEventEmitter {
    constructor() {
        this.listeners = {};
    }

    /**
     * Subscribe to an event
     * @param {string} event - Event name (e.g., 'unauthorized', 'tokenExpired')
     * @param {Function} callback - Callback to invoke
     * @returns {Function} Unsubscribe function
     */
    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);

        // Return unsubscribe function
        return () => {
            this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
        };
    }

    /**
     * Emit an event
     * @param {string} event - Event name
     * @param {*} data - Optional data to pass to listeners
     */
    emit(event, data) {
        if (this.listeners[event]) {
            this.listeners[event].forEach(callback => {
                try {
                    callback(data);
                } catch (error) {
                    console.error(`Error in auth event listener for ${event}:`, error);
                }
            });
        }
    }
}

// Singleton instance
export const authEvents = new AuthEventEmitter();

// Event constants
export const AUTH_EVENTS = {
    UNAUTHORIZED: 'unauthorized',      // 401 from API
    TOKEN_EXPIRED: 'tokenExpired',     // Token expired client-side
    TOKEN_EXPIRING_SOON: 'tokenExpiringSoon', // Token expiring in < 5 minutes
};

export default authEvents;
